<template>
  <button
    type="button"
    class="inline-flex shrink-0 items-center justify-center rounded-md bg-linear-to-br from-primary-400 to-primary-500 text-white shadow-xs transition hover:from-primary-500 hover:to-primary-600 focus:outline-hidden focus-visible:ring-2 focus-visible:ring-primary-300 disabled:cursor-not-allowed disabled:opacity-50"
    :class="small ? 'size-7 text-sm' : 'size-8'"
    :title="label"
    :aria-label="label"
    :disabled="disabled"
    @click.stop="$emit('click', $event)"
  >
    <FontAwesomeIcon :icon="['fas', icon]" />
  </button>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/**
 * The delete (or remove) button of a row, a card or a list item: solid red,
 * same everywhere. Its click does not reach the row.
 */
export default {
  name: 'BaseDeleteButton',
  components: { FontAwesomeIcon },
  props: {
    tooltip: { type: String, default: null },
    icon: { type: String, default: 'times' },
    small: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ['click'],
  computed: {
    label() {
      return this.tooltip ?? this.$t('button.delete')
    }
  }
}
</script>
